import React from 'react';
import { Icon } from '../../components/Icon';
import { Row, Column } from 'react-foundation';
import styled from 'styled-components';
import { PageHeader } from '../../components/PageHeader';
import { Button } from '../../components/Button';
import PropTypes from 'prop-types';
import SelectSubscriptionName from './SelectSubscriptionName';
import { SelectProductPackage } from './SelectProductPackage';
import SelectMobileNumber from './SelectMobileNumber';
import SelectBillingAddress from './SelectBillingAddress';
import OrderOverview from './OrderOverview';

const Wrapper = styled.div`
	margin-top: 5em;
	max-width: 100%;
`;

const Container = styled.div`
	box-sizing: border-box;
	width: 40em;
	height: 100%;
	max-width: 90%;
	@media only screen and (max-width: 600px) {
		width: 20em;
	}
	margin: auto;
	background-color: ${(props) => props.backgroundColor};
	padding: ${(props) => (props.wide ? '0' : '4em')};
`;

const ShoppingCart = styled.div`
	margin-bottom: 2em;
`;

const OrderedSubscriptionContainer = styled.div`
	min-height: 5em;
	max-width: 40em;
	margin: auto;
	padding: 1em;
	${(props) => (props.firstChild ? 'border-top: 1px solid #969696;' : '')}
	border-bottom: 1px solid #969696;
	position: relative;

	.subscription-name {
		font-size: 1.6em;
	}

	.package-description {
		font-size: 1.25em;
		line-height: 42.24px;
	}

	.icon-container {
		margin: 0 0 0.2em 0;
		float: right;
		display: inline-block;
	}

	.remove-text {
		margin-right: 2em;
		line-height: 42.24px;
	}

	.title-container {
		position: absolute;
		background-color: white;
		top: 0;
		left: 0;
		margin-top: -15px;
	}

	.title {
		padding: 0.2em 1em 0.2em 0;
	}
`;

const SuccessMessage = styled.div`
	margin: auto;
	text-align: center;
`;

const SubscriptionOrderContent = (props) => (
	<Wrapper>
		{!props.orderSubscriptionsFinished && !props.formSubmitted && <PageHeader>Tilaa uusi liittymä</PageHeader>}
		<div ref={(ref) => props.setRef(ref)}>
			{/*
        Purpose of this div is to wrap shopping cart to non-styled dom-element, so refs work as intended
      */}
			{!(props.formSubmitted && props.orderSubscriptionsFinished) && (
				<div>
					{props.subscriptionsToOrder.length > 0 && (
						<ShoppingCart>
							{props.subscriptionsToOrder.map((subscription, index) => (
								<OrderedSubscriptionContainer key={index} firstChild={index === 0}>
									{index === 0 && (
										<div className={'title-container'}>
											<span className={'title'}>Korin sisältö</span>
										</div>
									)}
									<Row>
										<Column large={5}>
											<span className={'subscription-name'}>{subscription.subscriptionName.value}</span>
										</Column>
										<Column large={7}>
											<span className={'package-description'}>
												{subscription.packageSpecs.value.displayName} {subscription.packageSpecs.value.eurPerMonth}/kk
											</span>
											<div className={'icon-container'}>
												<span className={'remove-text'}>Poista korista</span>
												<Icon onClick={() => props.onSubscriptionRemove(subscription)} name="medium--x--red" />
											</div>
										</Column>
									</Row>
								</OrderedSubscriptionContainer>
							))}
						</ShoppingCart>
					)}
					<Container backgroundColor={'#fafafa'}>
						<SelectSubscriptionName {...props} />
						<SelectProductPackage {...props} />
						<SelectMobileNumber {...props} />
					</Container>
					<Container backgroundColor={'white'} wide>
						<SelectBillingAddress {...props} />
						<OrderOverview {...props} />
					</Container>
					<Button onClick={props.onSubmit}>Lähetä tilaus</Button>
					<Button className="outlined" onClick={props.onSubscriptionAdd}>
						+ Lisää uusi liittymä
					</Button>
				</div>
			)}
		</div>
		{props.orderSubscriptionsFinished && props.formSubmitted && (
			<SuccessMessage>
				<Icon name="medium--ok" />
				<h4>Kiitos tilauksesta!</h4>
				<p>Uusi simmi lähetetään postitse viimeistään seuraavana arkipäivänä. Toimitus kestää noin 4-5 arkipäivää.</p>
				<Button className="outlined" onClick={props.onThankYouViewOkButtonClick}>
					OK
				</Button>
			</SuccessMessage>
		)}
	</Wrapper>
);

SubscriptionOrderContent.propTypes = {
	formSubmitted: PropTypes.bool,
	orderSubscriptionsFinished: PropTypes.bool,
	subscriptionsToOrder: PropTypes.array,
	onSubmit: PropTypes.func,
	onSubscriptionAdd: PropTypes.func,
	onThankYouViewOkButtonClick: PropTypes.func,
	offeringType: PropTypes.string
};

export default SubscriptionOrderContent;
